export default `
	fragment BreedsFragment on Breeds {
		id
		title
		weightPounds
		avgWeightPounds
		sizeCategory
		createdDate
		updatedDate
	}
`;
